import {Box, Loading} from '@viptech/react-components'
import {jwtDecode} from 'jwt-decode'
import {useEffect, useRef} from 'react'
import {useNavigate} from 'react-router-dom'
import {useAuth, type UserToken} from 'src/contexts/AuthContext'
import {isPortalRouteHybridEnabled, redirectToNewPortalAuth} from 'src/lib/portal-migration'
import {clearBridgeSessionParamsFromUrl, readBridgeSessionParams} from 'src/lib/portal-migration/read-bridge-session-params'
import api from 'src/services/api'
import storage from 'src/services/storage'

export default function BridgeSessionFromNew() {
  const hasRun = useRef(false)
  const navigate = useNavigate()
  const {checksToken} = useAuth()

  useEffect(() => {
    if (!isPortalRouteHybridEnabled() || hasRun.current) return
    hasRun.current = true

    const session = readBridgeSessionParams()

    if (!session) {
      if (redirectToNewPortalAuth('/login')) return
      window.location.replace('/login')
      return
    }

    try {
      const payload = jwtDecode(session.accessToken) as UserToken & {exp?: number}
      if (payload.exp && payload.exp <= Math.floor(Date.now() / 1000)) {
        if (redirectToNewPortalAuth('/login')) return
        window.location.replace('/login')
        return
      }
    } catch {
      if (redirectToNewPortalAuth('/login')) return
      window.location.replace('/login')
      return
    }

    storage.set('token', session.accessToken)
    storage.set('refreshToken', session.refreshToken)
    storage.set('keepLoggedIn', String(session.keepLoggedIn))
    api.setBearerToken(session.accessToken)
    clearBridgeSessionParamsFromUrl()

    const nextPath = session.next.startsWith('/') ? session.next : `/${session.next}`

    void (async () => {
      try {
        await checksToken()
        navigate(nextPath, {replace: true})
      } catch {
        if (redirectToNewPortalAuth('/login')) return
        window.location.replace('/login')
      }
    })()
  }, [checksToken, navigate])

  return (
    <Box height='100vh' display='flex' justifyContent='center' align='center'>
      <Loading size='30px' />
    </Box>
  )
}
